export const TRANSACTIONS_ROUTE = '/app/transactions';
